import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { bool, number, shape, string } from 'prop-types';
import { Text } from '@magalu/stereo-ui/atoms';
import { formatDiscountMessage } from '../../utils';
import { Container, Icon } from './tag-coupon.styles';

function TagCoupon(_ref) {
  let {
    tags,
    showIcon
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["tags", "showIcon"]);

  const discount = formatDiscountMessage(tags);
  return discount && /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    "data-testid": "productCard-coupon",
    "aria-label": `Cupom de ${discount.toLowerCase()}`
  }), showIcon && /*#__PURE__*/React.createElement(Icon, {
    "data-testid": "coupon-icon",
    color: "dark",
    name: "LocalActivity",
    mr: 1,
    height: 12,
    width: 12
  }), /*#__PURE__*/React.createElement(Text, {
    color: "dark"
  }, "Cupom ", discount));
}

TagCoupon.defaultProps = {
  tags: {},
  showIcon: true
};
process.env.NODE_ENV !== "production" ? TagCoupon.propTypes = {
  tags: shape({
    discountValue: number,
    discountType: string
  }),
  showIcon: bool
} : void 0;
export default TagCoupon;